// Create the ElevarDataLayer if it doesn't exist
window.ElevarDataLayer = window.ElevarDataLayer ?? [];

// Add the transform function to the ElevarDataLayer to modify the data before it's sent to Elevar
window.ElevarTransformFn = (event) => {
  // Save the original event data
  let data = event;

  // Add category to products to pass the Elevar validation
  ['add', 'cart_contents', 'remove', 'click', 'detail'].forEach((key) => {
    let products = data.ecommerce?.[key]?.products || [];
    if (products.length) {
      products = products.map((product) => {
        return {
          ...product,
          category: '{{ product.type | default: "Footwear" }}',
        };
      });
      data.ecommerce[key].products = products;
    }
  });

  // Return the data
  return data;
};

// Save each name="contact[email]" in the session storage so we can use it in the ElevarDataLayer
document.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('input[name="contact[email]"]').forEach((input) => {
    input.addEventListener('change', (event) => {
      const email = event.target.value;
      sessionStorage.setItem('elevar_email', email);
    });
  });
});

// When the customer has submitted the newsletter form, we want to send the email to the ElevarDataLayer
if (
  window.location.search.includes('customer_posted=true') &&
  sessionStorage.getItem('elevar_email')
) {
  window.ElevarDataLayer.push({
    event: 'dl_subscribe',
    lead_type: 'email',
    user_properties: {
      customer_email: sessionStorage.getItem('elevar_email'),
    },
  });
}
